/* Guía de tallas · Jenny Calderón Shoes
   1) Selector de unidad cm / pulgadas (recuerda la elección).
   2) Resalta la talla que la clienta tiene seleccionada en la ficha.
   3) En la ficha, el enlace "Guía de tallas" abre una ventana con el contenido de la página de la guía
      (una sola fuente de verdad: Rafael edita la página y la ventana cambia sola). Sin JS, el enlace navega. */
const CLAVE = 'jc_unidad';
const todos = (raiz, sel) => Array.from(raiz.querySelectorAll(sel));

function unidadGuardada(preferida) {
  try { return localStorage.getItem(CLAVE) || preferida; } catch (e) { return preferida; }
}
function aplicarUnidad(raiz, u) {
  raiz.dataset.unidad = u;
  todos(raiz, '[data-unidad-btn]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.unidadBtn === u)));
  todos(raiz, '[data-cm]').forEach((e) => { e.hidden = u !== 'cm'; });
  todos(raiz, '[data-in]').forEach((e) => { e.hidden = u !== 'in'; });
}
function tallaSeleccionada() {
  const radio = document.querySelector('input[type="radio"][data-option-name="Talla"]:checked, input[type="radio"][data-option-name="Size"]:checked');
  if (radio) return (radio.value || '').trim();
  const sel = document.querySelector('select[name="options[Talla]"], select[name="options[Size]"]');
  return sel ? (sel.value || '').trim() : '';
}
function resaltar(raiz) {
  const talla = tallaSeleccionada();
  todos(raiz, 'tr[data-talla]').forEach((tr) => {
    const activa = !!talla && (tr.dataset.talla || '').trim() === talla;
    tr.classList.toggle('is-activa', activa);
    const pill = tr.querySelector('[data-tu-talla]');
    if (pill) pill.hidden = !activa;
  });
}
function iniciar(raiz) {
  if (raiz.dataset.jcListo) return;
  raiz.dataset.jcListo = '1';
  aplicarUnidad(raiz, unidadGuardada(raiz.dataset.unidad || 'cm'));
  raiz.addEventListener('click', (e) => {
    const b = e.target.closest('[data-unidad-btn]');
    if (!b) return;
    aplicarUnidad(raiz, b.dataset.unidadBtn);
    try { localStorage.setItem(CLAVE, b.dataset.unidadBtn); } catch (err) { /* sin almacenamiento */ }
  });
  resaltar(raiz);
}
export function iniciarTodo(ambito) {
  todos(ambito || document, '[data-jc-guia]').forEach(iniciar);
}

/* ---- ventana emergente en la ficha ---- */
function dialogo() { return document.getElementById('jc-guia-dialogo'); }
function cargarGuia(url, cuerpo) {
  if (cuerpo.dataset.cargado) return Promise.resolve(true);
  if (!cuerpo._jcCarga) {
    cuerpo._jcCarga = fetch(url, { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.text() : Promise.reject(new Error('HTTP ' + r.status))))
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const el = doc.querySelector('[data-jc-guia]');
        if (!el) throw new Error('la página no tiene la sección Guía de tallas');
        const nodo = document.importNode(el, true);
        delete nodo.dataset.jcListo;
        cuerpo.replaceChildren(nodo);
        cuerpo.dataset.cargado = '1';
        iniciar(nodo);
        return true;
      })
      .catch(() => { cuerpo._jcCarga = null; return false; });
  }
  return cuerpo._jcCarga;
}
async function abrir(enlace) {
  const d = dialogo();
  if (!d) return false;
  const cuerpo = d.querySelector('[data-jc-guia-cuerpo]');
  if (!cuerpo) return false;
  await customElements.whenDefined('dialog-component');
  if (typeof d.showDialog !== 'function') return false;
  d.showDialog();
  const ok = await cargarGuia(enlace.href, cuerpo);
  if (!ok) { if (typeof d.closeDialog === 'function') d.closeDialog(); return false; }
  todos(cuerpo, '[data-jc-guia]').forEach(resaltar);
  return true;
}
document.addEventListener('click', (e) => {
  const a = e.target.closest('a[data-jc-guia-enlace]');
  if (!a || a.dataset.ventana !== 'true' || !dialogo()) return;
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
  e.preventDefault();
  abrir(a).then((ok) => { if (!ok) window.location.href = a.href; });
});
document.addEventListener('dialog:open', (e) => {
  if (e.target && e.target.id === 'jc-guia-dialogo') todos(e.target, '[data-jc-guia]').forEach(resaltar);
});
document.addEventListener('change', (e) => {
  const t = e.target;
  if (t && t.matches && t.matches('input[type="radio"][data-option-name], select[name^="options["]')) {
    todos(document, '[data-jc-guia]').forEach(resaltar);
  }
});
function precargar() {
  const a = document.querySelector('a[data-jc-guia-enlace][data-ventana="true"]');
  const d = dialogo();
  if (!a || !d) return;
  const cuerpo = d.querySelector('[data-jc-guia-cuerpo]');
  if (cuerpo) cargarGuia(a.href, cuerpo);
}
if ('requestIdleCallback' in window) window.requestIdleCallback(precargar, { timeout: 3000 }); else setTimeout(precargar, 1500);

iniciarTodo();
document.addEventListener('shopify:section:load', (e) => iniciarTodo(e.target));
